module.exports = __webpack_public_path__ + "03_long_grey.217c174f.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/mama/layer5/03_long_grey.png
// module id = Gm8F
// module chunks = 0